import Value from "./Value";
import { ValueType } from "./ValueType";
import BigNum from "../math/BigNum";

export default class BigNumValue extends Value {
    /**
     * @param {string} id 
     * @param {BigNum} initialValue
     */
    constructor(id, initialValue) {
        super(id);

        /**
         * @constant
         * @type {BigNum}
         */
        this.initialValue = new BigNum(0).copy(initialValue);

        /**
         * @type {BigNum}
         */
        this.value = new BigNum(0).copy(initialValue);
    }

    /**
     * @returns {BigNum}
     */
    getValue() {
        return this.value;
    }

    /**
     * @param {BigNum} value 
     */
    setValue(value) {
        this.value.copy(value);
    }

    setZero() {
        this.value.setZero();
    }

    /**
     * @param {BigNum} value 
     */
    incrementValue(value) {
        this.value.add(value);
    }
 
    /**
     * @override
     */
    reset() {
        this.value.copy(this.initialValue);
    }

    /**
     * @override
     * @returns {number}
     */
    getValueType() {
        return ValueType.BIG_NUM;
    }

    /**
     * @override
     * @returns {boolean}
     */
    isAtInitialValue() {
        return this.value.equals(this.initialValue);
    }

    /**
     * @override
     * @returns {boolean}
     */
    isValueApplicable() {
        return this.value.greaterThanZero();
    }
    
}